import React from 'react';
import { createPortal } from 'react-dom';

// An in-page confirmation, in the style of the app's other confirm dialogs:
// a title, what will happen, and No / Yes. tone 'danger' for an action that
// goes against a safeguard (overriding a decline).
const ConfirmDialog = ({ title, children, confirmLabel = 'Yes', cancelLabel = 'No', tone = 'primary', busy = false, onCancel, onConfirm }) => createPortal(
  <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
    <div className="bg-white dark:bg-slate-800 rounded-xl overflow-hidden w-full max-w-md"
      style={{ boxShadow: '0 20px 40px -8px rgba(0,0,0,0.18), 0 4px 16px -4px rgba(79,70,229,0.12)' }}
    >
      <div className="h-1" style={{ background: tone === 'danger' ? 'linear-gradient(90deg, #f43f5e, #e11d48)' : 'linear-gradient(90deg, #3b82f6, #6366f1, #8b5cf6)' }} />
      <div className="app-modal-header px-5 py-3.5 border-b border-indigo-100/60 dark:border-slate-700 flex items-center justify-between">
        <h3 id="confirm-dialog-title" className="text-sm font-semibold text-gray-800 dark:text-slate-100 flex items-center gap-2">
          <span className={`w-1 h-4 rounded-full inline-block flex-shrink-0 ${tone === 'danger' ? 'bg-rose-500' : 'bg-gradient-to-b from-blue-500 to-indigo-500'}`} />
          {title}
        </h3>
        <button
          type="button"
          onClick={onCancel}
          className="p-1.5 rounded-full text-gray-400 dark:text-slate-400 hover:bg-indigo-100/60 dark:hover:bg-slate-700 hover:text-indigo-600 dark:hover:text-slate-200 transition-colors"
          title="Close"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="p-5 space-y-4">
        <div className="text-sm text-gray-700 dark:text-slate-200 space-y-2">{children}</div>
        <div className="flex justify-end gap-3 pt-2 border-t border-indigo-50 dark:border-slate-700">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="px-4 py-2 bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-slate-200 rounded-lg hover:bg-gray-200 dark:hover:bg-slate-600 transition-colors font-medium text-sm border border-gray-200 dark:border-slate-600"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            autoFocus
            className={`px-4 py-2 rounded-lg transition-colors font-medium text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 text-white disabled:opacity-60 ${tone === 'danger' ? 'bg-rose-600 hover:bg-rose-700 focus:ring-rose-500' : 'bg-indigo-600 hover:bg-indigo-700'}`}
          >
            {busy ? 'Saving…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  </div>,
  document.body
);

export default ConfirmDialog;
